import {vm} from '@/main';

/**
 * 런타임시 Vue 인스턴스에 접근해야 하는 클래스는 이 클래스를 상속하면 됩니다.
 */
export default class VueAccessor {
    get vm() {
        return vm;
    }
}